import { MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH } from "static/constants";
import * as Yup from "yup";

export const manufacturerAccountValidationSchema = (isUpdate) =>
  Yup.object({
    manufacturer: Yup.string().required("Manufacturer is required"),
    account: Yup.string().required("Account is required"),
    username: Yup.string().required("Username is required"),
    password: isUpdate
      ? Yup.string()
      : Yup.string()
          .required("Password is required")
          .min(
            MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH,
            `Password must be at least ${MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH} characters long`
          ),
    confirmPassword: isUpdate
      ? Yup.string()
      : Yup.string()
          .required("Confirm password is required")
          .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
